import { render } from "./DedicatedCpu.vue?vue&type=template&id=f5263b0a&scoped=true"
import script from "./DedicatedCpu.vue?vue&type=script&lang=js"
export * from "./DedicatedCpu.vue?vue&type=script&lang=js"

import "./DedicatedCpu.vue?vue&type=style&index=0&id=f5263b0a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5263b0a"]])

export default __exports__